import React from "react";

const Icon = ({ path }) => (
  <svg
    width="20px"
    height="22px"
    viewBox="0 0 22 22"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    focusable="false"
  >
    <path d={path} />
  </svg>
);

export default Icon;
